/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./identity-auth0-context";

const CallBack = () => {
  const { signinRedirectCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    signinRedirectCallback?.()
      .then((appState: any) => {
        const target = appState?.returnTo || "/";
        navigate(target, { replace: true });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, [signinRedirectCallback, navigate]);

  return null;
};

export default CallBack;
